import { render, staticRenderFns } from "./SidebarCollapse.vue?vue&type=template&id=3cf53208&scoped=true&"
import script from "./SidebarCollapse.vue?vue&type=script&lang=js&"
export * from "./SidebarCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCollapse.vue?vue&type=style&index=0&id=3cf53208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf53208",
  null
  
)

export default component.exports